'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var COLOR_CUTOFFS = { high: 8, medium: 6, low: 0 };
var COLORS = {
    high: { background: '#4C7CFD', foreground: '#E1F0FF', focus: '#F6F8FC' },
    medium: { background: '#12253F', foreground: '#B8C3D2', focus: '#E3EBF6' },
    low: { background: '#EA5E57', foreground: '#FAD2D1', focus: '#FEF4F4' },
};
var ENTER_KEYCODE = 13;

exports.COLORS = COLORS;
exports.COLOR_CUTOFFS = COLOR_CUTOFFS;
exports.ENTER_KEYCODE = ENTER_KEYCODE;
